import React from 'react';
import PropTypes from 'prop-types';

import './makerCheckerView.scss';

const MakerDetailsView = props => {
    const { data } = props;
    return (
        <>
            <div className="checker-section-container">
                <h1 className="checker-section-title">
                    Maker Request Metadata
                </h1>
                <div className="form-section">
                    <div className="form-field">
                        <p className="label">Event Type</p>
                        <p className="user-text">{data.eventType.split('_').join(' ')}</p>
                    </div>
                    <div className="form-field">
                        <p className="label">Created At</p>
                        <p className="user-text">{data.createdAt}</p>
                    </div>
                    <div className="form-field">
                        <p className="label">Entity Code</p>
                        <p className="user-text">{data.idempotencyId}</p>
                    </div>
                    <div className="form-field">
                        <p className="label">Maker</p>
                        <p className="user-text">{data.makerId}</p>
                    </div>
                    <div className="form-field">
                        <p className="label">Request ID</p>
                        <p className="user-text">{data.makerRequestId}</p>
                    </div>
                    <div className="form-field">
                        <p className="label">Status</p>
                        <p className="user-text">{data.status}</p>
                    </div>
                </div>
            </div>
        </>
    );
};

MakerDetailsView.propTypes = {
    data: PropTypes.object,
};

export default MakerDetailsView;
